import { useState } from 'react';
import { TreeDeciduous, Loader2 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent } from '@/components/ui/card';

export function LoginPage() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const result = await signIn(email, password);
    if (result.error) {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-[360px]">
        {/* Brand */}
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <TreeDeciduous className="w-6 h-6 text-primary" />
          <span className="text-lg font-semibold text-foreground tracking-tight">
            Dancing Oaks
          </span>
        </div>

        {/* Card */}
        <Card>
          <CardContent className="pt-6">
            <h2 className="text-sm font-semibold text-foreground mb-1">Sign in</h2>
            <p className="text-[13px] text-muted-foreground mb-5">
              Enter your credentials to continue
            </p>

            <form onSubmit={handleSubmit} className="space-y-3">
              {error && (
                <div className="rounded-md bg-destructive/10 border border-destructive/20 p-3">
                  <p className="text-[13px] text-destructive">{error}</p>
                </div>
              )}

              <div>
                <label className="block text-[11px] font-medium text-muted-foreground uppercase tracking-wider mb-1.5">
                  Email
                </label>
                <Input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                />
              </div>

              <div>
                <label className="block text-[11px] font-medium text-muted-foreground uppercase tracking-wider mb-1.5">
                  Password
                </label>
                <Input
                  type="password"
                  required
                  minLength={6}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                />
              </div>

              <Button type="submit" disabled={loading} className="w-full">
                {loading && <Loader2 className="w-3.5 h-3.5 animate-spin" />}
                Sign in
              </Button>
            </form>
          </CardContent>
        </Card>

        {/* Accounts are created by an admin in Settings → User Management. */}
        <p className="text-center text-[13px] text-muted-foreground mt-4">
          Need access? Ask an admin to add you.
        </p>
      </div>
    </div>
  );
}
